module.exports = __webpack_public_path__ + "media/images/logo/nuevo_logo_g-f318b70ad64f67197852d16705e4e7ef.jpg";